import TopLogoPanel from "components/TopLogoPanel";
import Layout from "layouts";
import React from "react";
import RegisterComponent from "./RegisterComponent";

export default function Register() {
  return (
    <Layout noHeader maxWidth="xs">
      <TopLogoPanel>
        <RegisterComponent />
      </TopLogoPanel>
    </Layout>
  );
}
